import { Outlet, useNavigate } from "react-router-dom";
import { Box, useTheme } from "@mui/material";
// import { useEffect } from "react";

// Components
import Header from "./Header";
import LeftSideBar from "./LeftSideBar";

// Main layout component
const MainLayout: React.FC = () => {
  const theme = useTheme();
  return (
    <>
      <Box
        component="header"
        sx={{
          background: theme.palette.agrigradient.headerbggrd,
          height: "110px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Header />
      </Box>
      {/* Sidebar and main layout */}
      <Box
        sx={{ display: "flex", height: "calc(100vh - 110px)" }}
        component={"section"}
      >
        <Box
          component={"aside"}
          sx={{
            bgcolor: "sidebar.main",
            color: "sidebar.contrastText",
            width: "230px",
            margin: "15px",
            marginTop: "0px",
            borderRadius: "0 0 25px 25px",
          }}
        >
          <LeftSideBar />
        </Box>
        <Box
          component={"main"}
          sx={{
            flex: 1,
            paddingLeft: "30px",
            paddingRight: "30px",
            marginLeft: "auto",
            marginRight: "auto",
            maxWidth: "1360px",
            overflow: "hidden",
          }}
        >
          <main>
            <Outlet />
          </main>
        </Box>
      </Box>
    </>
  );
};

export default MainLayout;
